import React from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'

import { Box, Button, Paper } from '@material-ui/core'

import { MyServerTable } from './MyServerTable'

import { useStore } from '../hooks/storeHook'

import { appRoutes } from '../common/appRoutes'
import { userColumns } from '../types/userColumns'
import { makeStyles } from '@material-ui/core/styles'

export const AdminUsersScreen =
  observer(
    () => {
      const {user, adminStore: {users}} = useStore()
      const history = useHistory()

      const classes = useStyles()

      if (!user?.isSuperAdmin) {
        return null
      }

      return (
        <div className="body_wrapper_zero">
          <div className="body_wrapper">
            <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" marginBottom={2}>
              <h1 className={classes.title}>
                Пользователи
              </h1>

              <Box display="flex" flexWrap="wrap" alignItems="center">
                <Button
                  className={classes.navButton}
                  variant="outlined"
                  onClick={() => history.push(appRoutes.AdminMsAppLifecycle)}>
                  Статистика МС-приложения
                </Button>

                <Button
                  className={classes.navButton}
                  variant="outlined"
                  onClick={() => history.push(appRoutes.Account)}>
                  Аккаунт
                </Button>
              </Box>
            </Box>
          </div>

          <div className="body_wrapper">
            <Box display="flex" alignItems="center">
              <input
                autoFocus
                className="main_input"
                type="text"
                placeholder="Поиск"
                onChange={e => users.setGlobalFilter(e.target.value)}
              />
            </Box>
          </div>

          <div className={classes.tableWrapper}>
            <Box display="flex">
              <Paper className={classes.paper}>
                <MyServerTable
                  table={users}
                  columns={userColumns}
                  labelNoRows="Пользователей нет"
                  labelNotFound="Пользователи не найдены"
                  labelRowsPerPage="Пользователей на странице:"
                />
              </Paper>
            </Box>
          </div>
        </div>
      )
    })

const useStyles =
  makeStyles(
    ({spacing}) => ({
      title: {
        margin: 0
      },
      tableWrapper: {
        display: 'flex',
        width: 'fit-content'
      },
      paper: {
        width: 'calc(-300px + 100vw)'
      },
      navButton: {
        marginRight: spacing(1),
        marginBottom: spacing(1)
      }
    }))